import type {
  ViewerJobStatus,
  ViewerProjectDraft,
  ViewerProjectStatus,
} from "../../../../types/viewerDeployment";
import type {
  ViewerAuthoringDraftDto,
  ViewerAuthoringProjectStatusDto,
  ViewerDeploymentJobDto,
  ViewerDeployResultDto,
  ViewerPreviewReleaseDto,
} from "../types/viewerAuthoring.api";

function readStringValue(record: Record<string, unknown>, key: string): string | null {
  return typeof record[key] === "string" ? (record[key] as string) : null;
}

export function mapViewerProjectStatusToDto(
  status: ViewerProjectStatus,
): ViewerAuthoringProjectStatusDto {
  return {
    companyId: status.companyId,
    productId: status.productId,
    lifecycleState: status.state,
    hasLiveDeployment: status.hasLiveDeployment,
    currentPreviewReleaseId: status.currentPreviewReleaseId,
    currentLiveReleaseId: status.currentLiveReleaseId,
    previewUrl: status.previewUrl,
    liveUrl: status.liveUrl,
    contentVersion: status.contentVersion,
    updatedAtIso: status.updatedAt,
  };
}

export function mapViewerProjectDraftToDto(
  draft: ViewerProjectDraft,
): ViewerAuthoringDraftDto {
  return {
    companyId: draft.companyId,
    productId: draft.productId,
    revision: draft.revision,
    timelineSteps: draft.timelineSteps,
    visibilityAssignments: draft.visibilityAssignments,
    tools: draft.tools,
    parts: draft.parts,
    lastFrame: draft.lastFrame,
    updatedByUserId: draft.updatedByUserId,
    updatedAtIso: draft.updatedAt,
  };
}

export function mapViewerJobStatusToDto(
  jobStatus: ViewerJobStatus,
): ViewerDeploymentJobDto {
  return {
    jobId: jobStatus.jobId,
    status: jobStatus.status,
    targetReleaseId: jobStatus.targetReleaseId,
    errorMessage: jobStatus.errorMessage,
  };
}

export function mapPreviewPayloadToDto(payload: Record<string, unknown>): ViewerPreviewReleaseDto {
  return {
    releaseId: readStringValue(payload, "releaseId"),
    jobId: readStringValue(payload, "jobId"),
    previewUrl: readStringValue(payload, "previewUrl"),
    status: readStringValue(payload, "status") as ViewerPreviewReleaseDto['status'],
  };
}

export function mapDeployPayloadToDto(payload: Record<string, unknown>): ViewerDeployResultDto {
  return {
    jobId: readStringValue(payload, "jobId"),
  };
}
